import React from 'react';
import * as Styled from '../../../Footer.styles'; // Argos Section Only

var ReturnsFooter = function ReturnsFooter() {
  return /*#__PURE__*/React.createElement(Styled.ReturnsText, null, "For returns, product support and repairs", ' ', /*#__PURE__*/React.createElement("a", {
    href: "/help/returns-and-refunds/",
    "data-test": "footer-app-returns-link"
  }, "Learn more here"));
};

export default ReturnsFooter;